import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { ConfigService } from './config-service.interface';

export const DataAccessConfigService = new InjectionToken<ConfigService>(
  'ConfigService',
);

export interface ConfigServiceUseClass extends ClassSansProvider {
  useClass: Type<ConfigService>;
}

export interface ConfigServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => ConfigService;
}

export type ConfigServiceProvider =
  | ConfigServiceUseFactory
  | ConfigServiceUseClass;

export function provideDataAccessConfigService(config: ConfigServiceProvider) {
  return {
    provide: DataAccessConfigService,
    ...config,
  };
}
